import { render, staticRenderFns } from "./point_input.vue?vue&type=template&id=4ca6abc4&"
import script from "./point_input.vue?vue&type=script&lang=js&"
export * from "./point_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports